import { Directive } from '@angular/core';

@Directive({
    selector: '[st-header]',
})
export class HeaderDirective {}
